module.exports = __webpack_public_path__ + "img/IL.bf3de5de.svg";